import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

export function useUnlinkSystempartnerMutation(workshopId: number) {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof unlinkSystempartner>, ApiError, { systempartnerId: number }>({
    mutationKey: ['UnlinkSystempartner', workshopId],
    mutationFn: ({ systempartnerId }) => throwOnError(unlinkSystempartner(apiClient, workshopId, systempartnerId)),
  });
}

async function unlinkSystempartner(apiClient: ApiClient, workshopId: number, systempartnerId: number) {
  return apiClient.PUT('/op/v2/workshops/{workshop_id}/unlink-systempartner', {
    params: {
      path: {
        workshop_id: workshopId,
      },
    },
    body: {
      systempartner_id: systempartnerId,
    },
  });
}
